module.exports = __webpack_public_path__ + "static/media/win-normal-boss.4d838915.png";